import { api } from '@cwd/lib/main';

export interface ConnectionSummary {
    ConnectionId: string;
    Name: string;
    Data: string;
    Created: string;
    Modified: string | null;
    CreatedBy: string;
    ModifiedBy: string;
    Type: string;
}

export interface ConnectionProperty {
    Name: string;
    IsRequired: boolean;
    IsSecret: boolean;
    UseTextArea: boolean;
    Options: string[] | null;
    // Set only when this field declared [FieldAssistant] server-side - names an
    // entry in fieldAssistants.ts that can build this field's value
    // interactively. Null for every field on every integration that doesn't
    // have one - this is what keeps ConnectionForm.vue itself free of any
    // integration-specific knowledge.
    AssistantKey: string | null;
}

export interface ConnectionType {
    Name: string;
    DisplayName: string;
    Properties: ConnectionProperty[];
}

export async function getConnections(): Promise<ConnectionSummary[]> {
    return api.get('/Connections');
}

export async function getConnectionTypes(): Promise<ConnectionType[]> {
    return api.get('/Connections/ConnectionTypes');
}

export interface ConnectionSaveModel {
    Name: string;
    Type: string;
    Data: string;
}

export async function createConnection(connection: ConnectionSaveModel): Promise<ConnectionSummary> {
    return api.post('/Connections/Create', connection);
}

export async function updateConnection(connectionId: string, connection: ConnectionSaveModel): Promise<ConnectionSummary> {
    return api.post('/Connections/' + connectionId, connection);
}

export async function deleteConnection(connectionId: string): Promise<void> {
    return api.delete('/Connections/' + connectionId);
}
